export interface NamesPerson {
  nickName?: string;
  firstName: string;
  lastName?: string;
}

export interface Address {
  street: string;
  houseNumber: string;
  houseNumberExtension: string;
  city: string;
  postalCode: string;
  countryCode: string;
}

export enum GENDER_CODE_IMS {
  MALE = 'm',
  FEMALE = 'f',
  UNKNOWN = 'u',
  OTHER = 'o',
}

export interface DemographicsPerson {
  genderCode?: GENDER_CODE_IMS;
  genderCustom?: string;
  dateOfBirth?: string;
}

export interface ContactpointsPhone {
  phone: string;
}

export interface GetImsIdentityResponse {
  id: string;
  email: string;
  emailVerified: boolean;
  namesPerson?: NamesPerson;
  demographicsPerson?: DemographicsPerson;
  contactpointsPhone?: ContactpointsPhone;
  address?: Address;
}
